<template lang="pug">
  #BindSaIndex
</template>

<script>
  import { M_BIND_SA_SUCCESS } from '@/router/member/bind-sa';
  import { M_CHANGE_SA_INDEX } from '@/router/member/change-sa';
  import { M_SIGN_UP_INDEX } from '@/router/member/sign-up';

  export default {
  name: 'BindSaIndex',
  props: {
    sa_id: {
      type: [String, Number],
      required: true
    },
    store_id: {
      type: [String, Number],
      required: true
    }
  },
  mounted() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.$swal.fire({
      title: '綁定中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });

    // if (!this.sa_id && !this.store_id) {
    //   vm.$swal.fire({
    //     icon: 'error',
    //     title: '綁定失敗，請重新再嘗試一次[Err1]',
    //     showConfirmButton: false,
    //     showCancelButton: false,
    //     allowOutsideClick: false
    //   });
    //   return;
    // }

    vm.$store.dispatch('member_bind_sa/memberBindingSaHandler', {
      sa_id: this.sa_id,
      store_id: this.store_id
    })
      .then((res) => {
        if (res.message === 'success') {
          vm.$swal.close();
          console.log(res);
          vm.$store.commit('member_bind_sa/setSaInfo', {
            sa: res.data.after_sa,
            store: res.data.after_store
          });
          vm.$router.push({
            name: M_BIND_SA_SUCCESS
          });
        } else if (res.message === '進入換綁流程') {
          vm.$store.commit('member_change_sa/saveChangeSaInfo', res.data);
          vm.$swal.close();
          vm.$router.push({
            name: M_CHANGE_SA_INDEX
          });
        } else if (res.message === '進入開通會員流程') {
          vm.$swal.close();
          if (process.env.VUE_APP_IS_USE_CUSTOM_CRM === 'true') {
            const token = window.sessionStorage.getItem('token');
            const domain = `${process.env.VUE_APP_CUSTOM_CRM_BIND_URL}`;
            window.location = `${domain}?sa_id=${res.data.sa_id}&store_id=${res.data.store_id}&token=${token}`;
          } else {
            vm.$router.push({
              name: M_SIGN_UP_INDEX,
              params: {
                sa_id: res.data.sa_id,
                store_id: res.data.store_id
              }
            });
          }
        } else {
          vm.$swal.fire({
            icon: 'error',
            title: '綁定失敗，請重新再嘗試一次[Err2]',
            showConfirmButton: false,
            showCancelButton: false
          });
        }
      });
  }
};
</script>

<style>

</style>
